import BaseApiClient from "./base-client";
// API Class
class SegmentsApi extends BaseApiClient {
    SEGMENTS_BASE_PATH = "/api/segments";
    STUDY_SEGMENTS_BASE_PATH = "/api/studies";
    getSegments = () => this.get(this.SEGMENTS_BASE_PATH);
    getSegmentsForStudy = async (studyId, includeDeleted = false) => {
        return this.get(`${this.STUDY_SEGMENTS_BASE_PATH}/${studyId}/segments`, {
            params: {
                includeDeleted
            }
        });
    };
    createSegment = (segment, studyId) => {
        const path = studyId === undefined ? this.SEGMENTS_BASE_PATH : `${this.STUDY_SEGMENTS_BASE_PATH}/${studyId}/segments`;
        return this.post(path, {
            data: { ...segment }
        });
    };
    updateSegment = (segment) => this.patch(`${this.SEGMENTS_BASE_PATH}/${segment.segmentId}`, {
        data: { ...segment }
    });
    bulkSegmentUpdate = (segments) => this.patch(this.SEGMENTS_BASE_PATH, {
        data: [...segments]
    });
    deleteSegment = (segment) => this.delete(`${this.SEGMENTS_BASE_PATH}/${segment.segmentId}`);
    bulkSegmentDelete = (segments) => this.delete(`${this.SEGMENTS_BASE_PATH}?segmentIds=${segments.map((s) => s.segmentId).join(",")}`);
    restoreSegment = (segment) => this.patch(`${this.SEGMENTS_BASE_PATH}/${segment.segmentId}/restore`);
    bulkSegmentRestore = (segments) => {
        return this.patch(`${this.SEGMENTS_BASE_PATH}/restore`, {
            data: { segmentIds: segments.map((s) => s.segmentId) }
        });
    };
    archiveSegment = (segment) => this.patch(`${this.SEGMENTS_BASE_PATH}/${segment.segmentId}/archive`);
    bulkSegmentArchive = (segments) => this.patch(`${this.SEGMENTS_BASE_PATH}/archive`, {
        data: { segmentIds: segments.map((s) => s.segmentId) }
    });
    unarchiveSegment = (segment) => this.patch(`${this.SEGMENTS_BASE_PATH}/${segment.segmentId}/unarchive`);
    bulkSegmentUnarchive = (segments) => this.patch(`${this.SEGMENTS_BASE_PATH}/unarchive`, {
        data: { segmentIds: segments.map((s) => s.segmentId) }
    });
    static instance = new SegmentsApi();
}
export default SegmentsApi.instance;
